<template>
	<div :class="['menu-' + type, show ? 'show-menu' : '', top]">
		<el-menu
			class="el-menu-vertical-demo"
			:collapse="isCollapse"
			router
			unique-opened
			:default-active="defaultActive"
			active-text-color="#409EFF"
		>
			<template v-for="(item, index) in menuList">
				<el-menu-item
					:index="item.path"
					:key="index + ''"
					v-if="!item.children || !item.children.length"
				>
					<svg-icon
						class-name="icon-svg"
						:icon-class="item.icon"
						v-if="item.icon"
					></svg-icon>
					<span slot="title">{{ item.name }}</span>
				</el-menu-item>
				<el-submenu :index="index + ''" :key="index + ''" v-else>
					<template slot="title">
						<svg-icon
							class-name="icon-svg"
							:icon-class="item.icon"
							v-if="item.icon"
						></svg-icon>
						<span>{{ item.name }}</span>
					</template>

					<template v-for="(item1, index1) in item.children">
						<el-menu-item
							:index="item1.path"
							:key="index + '' + index1"
							v-if="!item1.children || !item1.children.length"
						>
							<svg-icon
								class-name="icon-svg"
								:icon-class="item1.icon"
								v-if="item1.icon"
							></svg-icon>
							<span slot="title">{{ item1.name }}</span>
						</el-menu-item>
						<el-submenu
							:index="index + '' + index1"
							:key="index + '' + index1"
							v-else
						>
							<template slot="title">
								<svg-icon
									class-name="icon-svg"
									:icon-class="item1.icon"
								></svg-icon>
								<span>{{ item1.name }}</span>
							</template>
							<template v-for="(item2, index2) in item1.children">
								<el-menu-item
									:index="item2.path"
									:key="index + '' + index1 + '' + index2"
									v-if="
										!item2.children ||
										!item2.children.length
									"
								>
									<svg-icon
										class-name="icon-svg"
										:icon-class="item2.icon"
										v-if="item2.icon"
									></svg-icon>
									<span slot="title">{{ item2.name }}</span>
								</el-menu-item>
							</template>
						</el-submenu>
					</template>
				</el-submenu>
			</template>
		</el-menu>
	</div>
</template>

<script type="text/javascript">
import Vuex from 'vuex';
import {} from '@/api/common.js';
import menu from './menu';
import { filterMenu } from '@/utils/util';

export default {
	data() {
		return {
			// menuList: filterMenu(menu)
		};
	},
	props: {
		type: String,
		show: Boolean,
		top: String
	},
	computed: {
		...Vuex.mapState({
			isCollapse: (state) => state.isCollapse,
			menuList: (state) => state.menuList
		}),
		defaultActive() {
			return this.$route.meta.activePath || this.$route.path;
		}
	},
	mounted() {
		// console.log(filterMenu(this.menuList));
	},
	methods: {}
};
</script>
<style lang="less">
.el-menu-vertical-demo {
	height: 100%;
	&.el-menu {
		background: @menu-background-color;
	}
	.el-submenu__title:hover {
		background: @menu-hover-color;
	}
	.el-menu-item:hover,
	.el-menu-item:focus {
		background: @menu-hover-color;
	}
	.el-submenu__title {
		color: @menu-title-color;
		background: @menu-background-color;
	}
	.el-submenu {
	}
	.el-menu-item {
		color: @menu-title-color;
		background: @menu-background-color;
		&:hover {
			background: @menu-hover-color;
		}
	}
	.icon-svg {
		width: 1.2em !important;
		height: 1.2em !important;
		margin-right: 10px;
		transform: translateY(2px);
	}
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 200px;
}
</style>
